import { render, staticRenderFns } from "./starsProgress.vue?vue&type=template&id=0ee04d26&"
import script from "./starsProgress.vue?vue&type=script&lang=js&"
export * from "./starsProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports